import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { type AppDispatch, type AppState } from "../../store/Store";
import { getErrorLogs } from "./modules/actions";

const mapStateToProps = (state: AppState) => ({
  state: {
    errorLogs: state.errorLogsReducer.errorLogs,
    total: state.errorLogsReducer.total,
    page: state.errorLogsReducer.page,
    loading: state.errorLogsReducer.loading,
  },
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getErrorLogs }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps);
